import React, {Component} from "react";
import withStaticImages from "../../../services/utils/imageNameRetriever";

import "./position-icon.css"

const positionIconStyle = {
    "width": "65px",
    "height": "65px"
};

class PositionIcon extends Component {
    render() {
        const _style = this.props.positionIconStyle || positionIconStyle;
        return this.positionIcon(_style);
    }

    positionIcon(_style) {
        const {className, position, showName} = this.props;
        const onClick = this.props.onClick;

        return position && (
            <div className="text-center position_icon_container" id={position.id}>
                {this.positionImage(_style, position, className, onClick)}
                {showName && this.positionLabel(position)}
            </div>
        );
    }

    positionImage(_style, position, className, onClick){

        if (!position || !Object.keys(position) || Object.keys(position).length === 0) {
            return (<div className='icon_not_available'>N/A</div>);
        }
    
        return (<img style={_style}
                    src={this.props.getImage(position.image_path)}
                    alt={position.image_filename}
                    className={`position_icon ${className}`}
                    onClick={onClick}
        />);
    };

    positionLabel(position) {
        return (<p className="m-0 pt-3 pb-0 px-0 small text-center text-secondary Position-Icon-label">{position.name}</p>);
    };


}




export default withStaticImages('position_icons',PositionIcon);



// WEBPACK FOOTER //
// ./src/components/components/position-icon/position-icon.js